<template>
  <div class="modal-600">
    <div class="overflow-auto" style="max-height: 600px">
      <div v-for="resposta in dados">
        <div class="alert" :class="resposta.tipo_usuario === 'A' ? 'crm-usuario' : 'crm-cliente'" role="alert">
          <div class="float-right">
            <h4 class="alert-heading">{{ resposta.data_cadastro }}</h4>
          </div>
          <h4 class="alert-heading">{{ resposta.usuario }}</h4>
          <hr>
          <p>{{ resposta.resposta }}</p>
        </div>
        <hr>
      </div>
    </div>
  </div>
  <div class="ibox-footer">
    <div class="float-right">
      <button id="btn-responder" class="btn btn-warning font-bold" data-toggle="modal" data-target="#incluirModalResposta"
              @click="exibirModal = true">
        Responder
      </button>
    </div>
    <button class="btn btn-success font-bold" @click="$emit('fechar')">
      Fechar
    </button>
  </div>

  <CadastrarRespostaCrm
      v-if="exibirModal"
      :itemSelect="itemSelect"
      @fecharSubModal="exibirModal = false"
      @atualizarRespostas="atualizarRespostas"
      @statusAtualizado="statusAtualizado"
  />

</template>

<script>
import BaseModal from '@/components/base/BaseModal.vue';
import CadastrarRespostaCrm from "@/views/crm/CadastrarRespostaCrm.vue";
import {apiRequest} from "../../../public/js/utils/funcoes";
import {apiUrl} from "@/router/apiBackRoutes";


export default {
  name: "SolicitacoesCrm",
  components: {
    CadastrarRespostaCrm,
    BaseModal,
  },
  props: {
    itemSelect: Number,
  },
  data() {
    return {
      dados: [],
      isAuthenticated: localStorage.getItem('admin_isAuthenticated'),
      exibirModal: false,
      erro: null,
    };
  },
  emits: ['fechar', 'atualizarRespostas', 'statusAtualizado'],
  methods: {
    atualizarRespostas(novaResposta) {
      this.dados.push(novaResposta);
    },
    statusAtualizado(payload) {
      this.$emit("statusAtualizado", payload);
    },
    async getDados() {
      const resultado = await apiRequest("GET", `${apiUrl.crm.createListResposta}?chamado=${this.itemSelect}`);

      if (resultado.success) {
        this.dados = resultado.data;
      } else {
        this.$toastMessage("warn", "Atenção", "Erro ao carregar registro!");
        console.error("Erro ao carregar:", resultado.error);
      }
    },
  },
  mounted() {
    this.getDados();
  },
}
</script>

<style scoped>
.modal-600 {
  height: 600px;
}
</style>
